module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "50%",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.$vars.error.show),
      callback: function($$v) {
        _vm.$set(_vm.$vars.error, "show", $$v)
      },
      expression: "$vars.error.show"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "orange darken-3 white--text"
  }, [_vm._v("\n      Es ist ein Fehler aufgetreten!\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.$vars.error.nachricht ? _vm.$vars.error.nachricht : 'Keine Nachricht') + "\n    ")]), _vm._v(" "), _c('v-card-subtitle', [_vm._v("\n      Weitere informationen zu dem Fehler\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      " + _vm._s(_vm.$vars.error.error ? _vm.$vars.error.error : 'Keine weiteren Informationen') + "\n    ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      Bitte schick ein Foto des Fehlers per Whatsapp an Benedikt Breuer oder per Mail an breuerbe@gmail.com. Vielen Dank!\n      Lade danach die Seite neu.\n    ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "orange darken-3",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.$vars.error.show = false
      }
    }
  }, [_vm._v("Schließen")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-563a6333"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/submodule/dialogError.vue
// module id = 783
// module chunks = 15